<table>
    <thead>
        <tr>
            <th></th>
            <th *ngFor="let year of invest.simulation.years">
                {{ year.year }}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of invest.simulation.itemsDetail">
            <td> {{ item.text.shortLabel }} </td>
            <td *ngFor="let year of invest.simulation.years; index as i">
                <app-invest-input *ngIf="i === 0 && item.code === 'extraFund'"
                    [isError]="checkError(year, item.code)"
                    [value]="getItemValue(year, item.code)"
                    (valueChanged)="onValueChanged($event, year, item.code)"></app-invest-input>

                <span *ngIf="i !== 0 || item.code !== 'extraFund'"
                    [ngClass]="{errorCell: checkError(year, item.code)}">
                    {{ getItemValue(year, item.code) | formatAmount }}
                </span>
            </td>
        </tr>
    </tbody>
</table>
